import React from 'react';
import { useIntl } from 'react-intl';

import { CSSEditor, CSSEditorWidgetProperties } from 'components/Editors/components/Editor.style';

import {
    JDatasourceApi,
    JFilebankApi,
    JWedocApi,
    Network,
    WidgetEditorActions,
    WidgetEditorErrorActions,
    WidgetExcelDatasourceTableContent,
} from 'jamespot-user-api';

import { JRCButton } from 'components/JRCButton/JRCButton';

import { ExcelEditor } from './model/excel/ExcelEditor';
import { EditorBaseContext, EditorContainerProvider, Handlers, HookIsActive } from '../context/provider';
import { JRCWidgetTableSharedEditor } from './JRCWidgetTableSharedEditor';

export type WidgetExcelDatasourceHandlers = Handlers & {
    jamespot: {
        datasource: Omit<JDatasourceApi, 'jApi' | 'network'>;
        network: Pick<Network, 'token' | 'postFile' | 'getUrl'>;
        filebank: Pick<JFilebankApi, 'getBanks' | 'getFolders' | 'getDocuments'>;
        wedoc: Pick<JWedocApi, 'getFiles'>;
    };
};

export type WidgetExcelDatasourceContext = EditorBaseContext<WidgetExcelDatasourceTableContent> & {
    handlers: WidgetExcelDatasourceHandlers;
};

export const JRCWidgetExcelDatasourceTableEditor = ({
    uri,
    limit = 20,
    tableHeadColor,
    tableHeadTextColor,
    tableHeadIconColor,
    tableRowColor,
    tableRowTextColor,
    tableColumnsData = [],
    tableSizedColumns,
    tableSizedColumnsWidth,
    tableBorderRadius,
    hook,
    handlers,
    onChange,
    onSave,
    onStateChange,
    onError,
}: WidgetExcelDatasourceTableContent & {
    handlers: WidgetExcelDatasourceHandlers;
} & {
    hook: {
        isActive: HookIsActive;
    };
} & WidgetEditorActions<WidgetExcelDatasourceTableContent> &
    WidgetEditorErrorActions) => {
    const intl = useIntl();

    return (
        <EditorContainerProvider<WidgetExcelDatasourceContext>
            hook={hook}
            handlers={handlers}
            onSave={onSave}
            onChange={onChange}
            onStateChange={onStateChange}
            onError={onError}>
            <CSSEditor>
                <CSSEditorWidgetProperties>
                    <ExcelEditor uri={uri ?? undefined} tableColumnsData={tableColumnsData} />
                    {uri && tableColumnsData.length ? (
                        <JRCWidgetTableSharedEditor
                            limit={limit}
                            tableHeadColor={tableHeadColor}
                            tableHeadTextColor={tableHeadTextColor}
                            tableHeadIconColor={tableHeadIconColor}
                            tableRowColor={tableRowColor}
                            tableRowTextColor={tableRowTextColor}
                            tableSizedColumns={tableSizedColumns}
                            tableSizedColumnsWidth={tableSizedColumnsWidth}
                            tableBorderRadius={tableBorderRadius}
                            onChange={onChange}
                        />
                    ) : (
                        <></>
                    )}
                </CSSEditorWidgetProperties>
                {uri && (
                    <JRCButton onClick={() => onSave({})} color={'primary'} minWidth={'100%'} noMargin>
                        {intl.formatMessage({ id: 'PANEL_Save_And_Close' })}
                    </JRCButton>
                )}
            </CSSEditor>
        </EditorContainerProvider>
    );
};
